<template>
  <v-dialog v-model="dialog" max-width="480" persistent>
    <v-card>

      <!-- Header -->
      <div style="background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%); padding: 16px 20px; display: flex; align-items: center; gap: 12px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="38">
          <v-icon color="white" size="20">mdi-set-split</v-icon>
        </v-avatar>
        <div>
          <div style="font-size: 1rem; font-weight: 700; color: #fff;">Asignar Plataforma Moodle</div>
          <div style="font-size: 0.75rem; color: rgba(255,255,255,0.65);">Seleccione la plataforma para este programa</div>
        </div>
      </div>

      <v-card-text class="pt-4 pb-2 px-5">

        <!-- Plataforma actual -->
        <div class="ap-info-row mb-4">
          <span class="ap-label">Actual</span>
          <span class="ap-value">{{ datamsg }}</span>
        </div>

        <v-combobox
          v-model="selected"
          :items="plataformas"
          item-text="name"
          label="Seleccionar plataforma"
          hint="Escriba o seleccione la plataforma de Moodle"
          persistent-hint
          dense outlined
          prepend-inner-icon="mdi-monitor-multiple"
          clearable
        />

      </v-card-text>

      <v-card-actions class="px-5 pb-4">
        <v-spacer />
        <v-btn text @click="closeDialog">Cancelar</v-btn>
        <v-btn color="indigo darken-1" dark depressed
          :disabled="!selected" @click="assignPlataformaToPrograma">
          <v-icon left small>mdi-check</v-icon> Asignar
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import gql from 'graphql-tag';
import { mapState } from 'vuex';

export default {
  props: ['programa'],
  data() {
    return {
      selected: null,
      plataformas: [],
      dialog: false,
      isdevmode: false,
      datamsg: 'No tiene plataforma asignada',
    };
  },
  watch: {
    UNIDAD_NEGOCIO_ID() {
      this.plataformas = [];
      this.getDatosPlataformas();
    },
  },
  computed: {
    ...mapState({
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
    }),
  },
  methods: {
    assignPlataformaToPrograma() {
      this.$root.$confirm.open('Asignar Plataforma', 'Estas seguro de asignar?', { color: 'orange' }).then((confirm) => {
        if (this.programa && this.selected && confirm) {
          const sql = gql`mutation{asignarPlataforma(input:{ programa_id: ${this.programa.id}, plataforma_id: ${this.selected.id} }){ok errors{message}} }`;
          this.$apollo
            .mutate({ mutation: sql })
            .then(({ data: { asignarPlataforma } }) => {
              if (asignarPlataforma.ok) {
                this.$root.$notify.show('ID Plataforma Asignado Exitosamente', { color: 'success' });
                this.programa.plataforma_id = this.selected.id;
                this.$emit('reloadGetPlataforma');
              } else {
                asignarPlataforma.errors.forEach((error) =>
                  this.$root.$notify.show('ERROR:' + error.message, { color: 'red' }),
                );
              }
              this.dialog = false;
            })
            .catch((err) => this.$root.$notify.show(`ERROR: Asignar Plataforma ${err}`, { color: 'red' }));
        }
      });
    },
    getDatosPlataformas() {
      let xgql = '';
      if (this.isdevmode) xgql = gql`query { getPlataformas { id nombre direccion unidad_negocio_id estado }}`;
      else xgql = gql`query { getPlataformas(estado: true,unidad_negocio_id: ${this.UNIDAD_NEGOCIO_ID}) { id nombre direccion unidad_negocio_id estado }}`;
      this.$apollo
        .query({ query: xgql })
        .then(({ data: { getPlataformas } }) => {
          this.plataformas = getPlataformas.map((item) => {
            item.name = item.nombre.toUpperCase() + '  —  ' + item.direccion;
            return item;
          });
        })
        .catch((err) => this.$root.$notify.show(`ERROR: getPlataformas(DialogAssignPla) ${err}`));
    },
    closeDialog() {
      this.dialog = false;
    },
    setPlataforma(p) {
      this.datamsg = p?.nombre && p?.direccion ? `${p.nombre}  [${p.direccion}]` : 'No tiene plataforma asignada';
    },
  },
  mounted() {
    const apidev = process.env.VUE_APP_GRAPHQL;
    if (apidev.includes('apidev')) this.isdevmode = true;
    this.getDatosPlataformas();
  },
};
</script>

<style scoped>
.ap-info-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.85rem;
}
.ap-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #7986cb;
  min-width: 60px;
}
.ap-value {
  color: #283593;
  font-weight: 500;
}
</style>
